import { Permissions } from "../../models/enums/permissions";

interface IProps {
    currentPermissions  : Permissions[];
    requiredPermissions : Permissions[];
}

/**
 * Whether a user holds at least one of the permissions that are asked for. Asking for none is asking for nothing, so
 * everyone who is signed in passes.
 * @param props What the user holds, and what is asked for
 */
export function validatePermission(props: IProps): boolean {

    const { currentPermissions, requiredPermissions } = props;

    if (!requiredPermissions || requiredPermissions.length === 0) {
        return true;
    }

    if (!currentPermissions || currentPermissions.length === 0) {
        return false;
    }

    return requiredPermissions.some(required => currentPermissions.indexOf(required) >= 0);
}
